var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from "classnames";
import React, { forwardRef, useEffect, useRef } from "react";
import { isIconToken } from "../../tokens/icons.js";
import { QuiIcon } from "../_primitives/QuiIcon/QuiIcon.js";
export const QUI_TEXT_INPUT_ICON_SIZE = {
    sm: "md",
    md: "md",
    lg: "md",
    xl: "2xl",
};
function QuiTextInputIcon({ icon, size }) {
    if (icon === undefined)
        return null;
    if (isIconToken(icon)) {
        return React.createElement(QuiIcon, { size: QUI_TEXT_INPUT_ICON_SIZE[size], icon: icon });
    }
    return icon;
}
/** Simple uncontrolled text input component */
export const QuiTextInput = forwardRef((_a, ref) => {
    var { disabled, iconLeft, iconRight, size, className, invalid, textAlign } = _a, otherProps = __rest(_a, ["disabled", "iconLeft", "iconRight", "size", "className", "invalid", "textAlign"]);
    const wrapperRef = useRef(null);
    const internalInputRef = useRef(null);
    const wrapperClassName = classNames(`qui-text-input`, `qui-input-${size !== null && size !== void 0 ? size : "md"}`, className, {
        "qui-invalid": invalid,
        "qui-text-input-disabled": disabled,
        "qui-text-input-with-icon-left": !!iconLeft,
        "qui-text-input-with-icon-right": !!iconRight,
    });
    useEffect(() => {
        const abortController = new AbortController();
        if (wrapperRef.current) {
            wrapperRef.current.addEventListener("click", (e) => {
                var _a;
                if (e.target instanceof HTMLInputElement) {
                    return;
                }
                (_a = internalInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, { signal: abortController.signal });
        }
        return () => {
            abortController.abort();
        };
    }, []);
    return (React.createElement("div", { ref: wrapperRef, className: wrapperClassName },
        React.createElement(QuiTextInputIcon, { icon: iconLeft, size: size !== null && size !== void 0 ? size : "md" }),
        React.createElement("input", Object.assign({ ref: (node) => {
                internalInputRef.current = node;
                if (typeof ref === "function") {
                    ref(node);
                }
                else if (ref) {
                    ref.current = node;
                }
            }, className: classNames({
                [`qui-text-align-${textAlign}`]: textAlign,
            }), disabled: disabled }, otherProps)),
        React.createElement(QuiTextInputIcon, { icon: iconRight, size: size !== null && size !== void 0 ? size : "md" })));
});
QuiTextInput.displayName = "QuiTextInput";
